export interface EventVisibilityRule {
  /** Título da combinação, ex.: "Gratuito · Privado". */
  title: string;
  /** Resumo curto exibido em destaque. */
  summary: string;
  /** Regras de divulgação (onde o evento aparece). */
  promotion: string[];
  /** Regras de URL e acesso. */
  access: string[];
  /** Regras de ingressos. */
  tickets: string[];
}

export type EventVisibilityRuleKey =
  | "paid_public"
  | "paid_private"
  | "free_public"
  | "free_private";

/**
 * Matriz pago/gratuito × público/privado exibida na etapa de configuração
 * do evento. Conteúdo conforme as regras de negócio da plataforma.
 */
export const EVENT_VISIBILITY_RULES: Record<
  EventVisibilityRuleKey,
  EventVisibilityRule
> = {
  paid_public: {
    title: "Pago · Público",
    summary:
      "Evento aberto, com ingressos vendidos e divulgação completa na plataforma.",
    promotion: [
      "Aparece na página inicial, em buscas, categorias e destaques",
      "Pode ser compartilhado livremente",
    ],
    access: ["URL pública do evento"],
    tickets: [
      "Preço definido pelo produtor",
      "Quantidade limitada ou ilimitada",
      "Pagamento via gateway habilitado",
    ],
  },
  paid_private: {
    title: "Pago · Privado",
    summary: "Evento pago acessível apenas por quem tem o link.",
    promotion: [
      "Não aparece na página inicial nem em buscas",
      "Acesso somente via link",
    ],
    access: ["URL privada (não indexada)"],
    tickets: [
      "Preço definido pelo produtor",
      "Quantidade limitada ou ilimitada",
      "Pagamento via gateway habilitado",
    ],
  },
  free_public: {
    title: "Gratuito · Público",
    summary: "Evento gratuito e aberto, com retirada livre de ingressos.",
    promotion: [
      "Aparece na página inicial, em buscas e categorias",
      "Pode ser compartilhado livremente",
    ],
    access: ["URL pública do evento"],
    tickets: [
      "Valor R$ 0,00",
      "Controle de quantidade",
      "Gera ingresso e QR Code normalmente",
    ],
  },
  free_private: {
    title: "Gratuito · Privado",
    summary: "Evento gratuito e fechado, com acesso somente por convite.",
    promotion: [
      "Não aparece na página inicial nem em buscas",
      "Acesso controlado por convite",
    ],
    access: [
      "URL fechada (não indexada)",
      "Usuário precisa estar logado",
      "O e-mail do login deve estar na lista de convidados",
      'Caso contrário: "Este evento é exclusivo para convidados"',
    ],
    tickets: ["Gratuitos, gerados individualmente", "Gera ingresso e QR Code"],
  },
};
